import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useRestoreKeyFactsMutation = ({
	onError,
	onSuccess,
	impersonationContext,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IOperationResult<number>) => void;
	impersonationContext?: Api.IImpersonationContext;
}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ request, contactId }: { request: Api.IRestoreKeyFactsRequest; contactId?: string }) => {
			const urlPath = contactId ? `keyfact/restore/contact/${contactId}` : `keyfact/restore`;
			return userSession.webServiceHelper.callAsync<Api.IOperationResult<number>>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath,
				}),
				'POST',
				request
			);
		},
		onError,
		onSuccess,
	});
};
